import { message } from "antd";

/** 禁用浏览器一些功能 */
function banDocument() {
  document.body.oncontextmenu = e => {
    console.log(e, '右键');
    // return false;
    e.preventDefault();
  };
  // 禁止文字选择。
  document.body.onselectstart = e => {
    console.log(e, '文字选择');
    // return false;
    e.preventDefault();
  };
  // 禁止复制
  document.body.oncopy = e => {
    console.log(e, 'copy');
    // return false;
    e.preventDefault();
  };
  // 禁止剪切
  document.body.oncut = e => {
    console.log(e, 'cut');
    // return false;
    e.preventDefault();
  };
  // 禁止粘贴
  document.body.onpaste = e => {
    console.log(e, 'paste');
    // return false;
    e.preventDefault();
  };
}

/** 禁用可能作弊的快捷键功能 */
function banKeyboard() {
  document.onkeydown = (e) => {
    console.log(e.code);
    if (
      e.code === 'F1' || // 屏蔽 F1
      e.code === 'F5' || // 屏蔽 F5
      e.code === 'F12' || // 屏蔽 F12
      (e.ctrlKey && e.code === 'KeyN') || // 屏蔽 Ctrl + N
      (e.shiftKey && e.code === 'F10') // 屏蔽 Shift+F10
    ) {
      return false;
    }
    if (e.altKey && e.code === 'F4') {
      // 屏蔽Alt+F4
      return false;
    }

    if (e.altKey && (e.code === 'ArrowLeft' || e.code === 'ArrowRight')) {
      message.error('不准你使用ALT+方向键前进或后退网页！');
      return false;
    }
  };
}

/** 检测切换屏幕 */
function windowSwitch(callback:(time: number) => void) {
  let blurTime = 0;
  let allTime = 0;
  window.onblur = () => {
    blurTime = Date.now();
    console.log('blur');
  };
  window.onfocus = () => {
    if(blurTime) {
      allTime += Date.now() - blurTime;
    }
    callback(allTime);
    console.log('focus', allTime + 'ms');
  };
}

/** 综合禁用功能 */
function banCheating() {
  banDocument();
  banKeyboard();
}

export { banCheating, windowSwitch, banDocument, banKeyboard };
